export default __webpack_public_path__ + "static/BenMain-017f25c1165f5d497c87fafa1f417ac5.png";